var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("SummaryReport.Collaboration.Title")) + "\n  "
      )
    ]),
    _vm._v(" "),
    _vm.collaboration
      ? _c(
          "div",
          [
            _c(
              "h3",
              { staticClass: "mt-0" },
              [
                _c("plain-text-control", {
                  attrs: {
                    title: "SummaryReport.Collaboration.Volunteers.Title"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("radio-button-row", {
              key: _vm.radioButtonValueChanged,
              attrs: {
                title: "SummaryReport.Collaboration.Volunteers.HasVolunteers",
                required: true
              },
              model: {
                value: _vm.volunteers.hasVolunteers,
                callback: function($$v) {
                  _vm.$set(_vm.volunteers, "hasVolunteers", $$v)
                },
                expression: "volunteers.hasVolunteers"
              }
            }),
            _vm._v(" "),
            _vm.collaboration.volunteers.hasVolunteers
              ? _c(
                  "div",
                  [
                    _c("numeric-input-row", {
                      attrs: {
                        title: "SummaryReport.Collaboration.Volunteers.Count",
                        id: "volunteercount",
                        required: true
                      },
                      model: {
                        value: _vm.volunteers.count,
                        callback: function($$v) {
                          _vm.$set(_vm.volunteers, "count", $$v)
                        },
                        expression: "volunteers.count"
                      }
                    }),
                    _vm._v(" "),
                    _c("text-area-row", {
                      attrs: {
                        title:
                          "SummaryReport.Collaboration.Volunteers.TaskDescription",
                        id: "volunteertaskdescription",
                        required: true,
                        maxLength: 500,
                        rows: 5
                      },
                      model: {
                        value: _vm.volunteers.taskDescription,
                        callback: function($$v) {
                          _vm.$set(_vm.volunteers, "taskDescription", $$v)
                        },
                        expression: "volunteers.taskDescription"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "h3",
              [
                _c("plain-text-control", {
                  attrs: { title: "SummaryReport.Collaboration.Partners.Title" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("partners-control", {
              attrs: {
                model: _vm.collaboration.partners,
                reportYear: _vm.reportYear
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }